import React, { useState } from 'react'
import { useNavigator } from '../../utitlities/navigation'
import { useEffect } from 'react'
import { getRewards } from './api'
function OldRewardesign ({ title, data, searchQuery, viewToBuy }) {
  const [navigator] = useNavigator()
  const [rewardsdata, setRewardsdeata] = useState([])

  useEffect(() => {
    window?.scrollTo(0, 0)
    if (data != undefined) {
      setRewardsdeata(data)
    } else {
      getRewards?.getSearchResult(searchQuery, (err, data) => {
        if (err == null) {
          setRewardsdeata(data?.data?.data)
        } else {
          setRewardsdeata([])
        }
      })
    }
  }, [])
  return (
    <section class='collection-explore pt-sm-90'>
      <div class='overlay py-5 py-lg-5 position-relative'>
        <div class='container-fluid px-3 px-lg-5'>
          <div class='row py-3 align-items-center'>
            <div class='col-md-4'>
              <div class='col-inner text-center text-md-start mb-4 mb-md-0 more-reward'>
                <h1 class='mb-2'>
                  {title == undefined ? 'Reward Search' : title}
                </h1>
                <span class='result-col d-block mb-3'>
                  {data?.length} RESULTS
                </span>
              </div>
            </div>
          </div>
          <div
            class='row pb-4 reward-card-row more-reward-row'
            id='reward-gallery'
          >
            {rewardsdata?.map(item => {
              return (
                <div
                  class='col-6 col-lg-4 mb-3 filter entertainment travel'
                  onClick={() => {
                    viewToBuy(item)
                  }}
                >
                  <div class='card h-100 border-0'>
                    <div class='card-img'>
                      <img src={item?.image} alt='rwd-img-1' />
                    </div>
                    <div class='card-body px-0'>
                      <div class='row'>
                        <div class='col-12'>
                          <p>
                            {item?.service_name} with {item?.athlete_name}
                          </p>
                          <p class='chanel-name'>Ex-Sports</p>
                        </div>
                      </div>
                      <div class='row'>
                        <div class='col-12'>
                          <p>
                            <span class='price'>
                              <img
                                style={{ marginRight: '5px' }}
                                src={
                                  item?.currency?.toUpperCase() == 'USDT'
                                    ? '../../assets/images/icons/tether.svg'
                                    : '../../assets/images/icons/Ex-coin.svg'
                                }
                                alt='coin-img'
                              />
                              {item?.price_set_by_athlete}{' '}
                              {item?.currency?.toUpperCase()}
                            </span>
                            {/* <span class='remin-item'>Last 3 Item</span> */}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )
            })}
          </div>

          {/* <div class='row reward-card-row'>
            <div class='col-12 text-center pt-4'>
              <a href='#' class='btn btn-light-outline w-25'>
                Load More
              </a>
            </div>
          </div> */}
        </div>
      </div>
    </section>
  )
}

export default OldRewardesign
